var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-bold",class:{ 'text-danger': _vm.message!=null && _vm.message.error,
      'text-success':_vm.message!=null && _vm.message.success }},[_vm._v(" "+_vm._s(_vm.message!=null ? (_vm.message.error || _vm.message.success) : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }